module.exports = __webpack_public_path__ + "img/linkedinline.6195ee5c.svg";